import React from 'react'
import ImageBox from './ImageBox'

const Team = () => {
  return (
    <div >
        
        <div >
<ImageBox/>
  
</div>

  
    </div>
  )
}

export default Team